export default "__VITE_ASSET__CwWAU5dh__"